export default testslist = {
    "ember/test/k": require("./ember/test/tests/test_k.json"),
    "ember/test/l": require("./ember/test/tests/test_l.json"),
}
